export default "__VITE_ASSET__CFqUt7yu__"